import {
  titleUI,
  currentOrPastDateUI,
  currentOrPastDateSchema,
  checkboxUI,
  checkboxSchema,
  textUI,
  selectUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import {
  STATE_NAMES,
  STATE_VALUES,
  COUNTRY_NAMES,
  COUNTRY_VALUES,
} from '../../../../utils/labels';
import { formatFullName } from '../../../../utils/helpers';
import { customAddressSchema } from '../../../../config/definitions';
import content from '../../../../utils/content.json';

export const birthInformationTitle = ({ formData }) => {
  const name = formData?.childFullName
    ? formatFullName(formData.childFullName)
    : '';
  return `${name || 'Child'}’s birth information`;
};

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(birthInformationTitle),
    childDateOfBirth: currentOrPastDateUI({
      title: content['household-dependents-array-dob-place-dob'],
      monthSelect: true,
      errorMessages: {
        required: content['household-dependents-array-dob-place-dob-error'],
      },
    }),
    bornOutsideUs: checkboxUI({
      title: content['household-dependents-array-dob-place-born-outside-us'],
    }),
    birthPlace: {
      city: {
        ...textUI(content['address-city']),
        'ui:errorMessages': {
          required: content['address-city-error'],
        },
      },
      state: {
        ...selectUI(content['address-state'], STATE_VALUES, STATE_NAMES),
        'ui:required': formData => !formData?.bornOutsideUs,
        'ui:options': {
          hideIf: formData => !!formData?.bornOutsideUs,
        },
        'ui:errorMessages': {
          required: content['address-state-error'],
        },
      },
      otherCountry: {
        ...selectUI(content['address-country'], COUNTRY_VALUES, COUNTRY_NAMES),
        'ui:required': formData => !!formData?.bornOutsideUs,
        'ui:options': {
          hideIf: formData => !formData?.bornOutsideUs,
          labels: COUNTRY_VALUES.reduce(
            (labels, value, index) => ({
              ...labels,
              [value]: COUNTRY_NAMES[index],
            }),
            {},
          ),
        },
        'ui:errorMessages': {
          required: content['address-country-error'],
        },
      },
    },
  },
  schema: {
    type: 'object',
    required: ['childDateOfBirth', 'birthPlace'],
    properties: {
      childDateOfBirth: currentOrPastDateSchema,
      bornOutsideUs: checkboxSchema,
      birthPlace: customAddressSchema,
    },
  },
};
